module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CN",
    attrs: {
      "id": "_idParaDest-5"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "Q_F ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Language is a skin: I rub my language against the other. It is as if I had words instead of fingers, or fingers at the tip of my words. My language trembles with desire.")])]), _vm._v(" "), _c('p', {
    staticClass: "Q_F ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("—")]), _c('span', {
    staticClass: "I CharOverride-9"
  }, [_vm._v("Fragments d’un discours amoureux")]), _c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v(",")])]), _vm._v(" "), _c('p', {
    staticClass: "Q_F ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("Roland Barthes")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-285cfcf4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/97808021495414.vue
// module id = 75
// module chunks = 0